import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import Input from '../form/input';

import util from '../../lib/util';
import style from './style.css';

const initialState = {
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false,
    },
};

@observer
class ConsumerList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
            previewServer: util.getPreviewServer(),
        };
        this.updateTimer = {};

        const { consumerStore } = this.props.stores;
        consumerStore.list();
    }

    handleScroll = () => {
        const { loading } = this.state;
        const { consumerStore } = this.props.stores;
        const { totalAppend, limit } = consumerStore;
        if (window.innerHeight + document.documentElement.scrollTop + 500
            < document.documentElement.offsetHeight) return;
        if (loading) return;

        let offset = consumerStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(this.scrollLoader);
            this.scrollLoader = setTimeout(async () => {
                this.setState({ loading: true });
                consumerStore.updateOffset(offset);
                await consumerStore.list(true);
                this.setState({ loading: false });
            }, 500);
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    async updateField(id, field, value) {
        const { consumerStore } = this.props.stores;
        consumerStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { consumerStore } = this.props.stores;
        await consumerStore.saveField(id, field, value);
    }

    delete = async (event) => {
        const { id } = event.target.dataset;
        const { consumerStore } = this.props.stores;
        await consumerStore.delete(id);
        consumerStore.markDeleted(id);
    }

    render() {
        const { loading, previewServer } = this.state;
        const { consumerStore } = this.props.stores;
        const { consumers, queryFilter, saved, deleted } = consumerStore;

        return (
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-12'>
                        <small class='text-muted font-weight-lighter float-right mr-2'>
                            Total: {consumerStore.total}<br />
                        </small>

                        <span class='float-left form-row align-items-center mr-5'>
                            <div class='col-auto'>
                                <input type='text' class='form-control form-control-sm' id='inlineFormInputName' placeholder='Search for consumers...'
                                    onInput={e => consumerStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true })}
                                    value={queryFilter.search}
                                />
                            </div>
                            <div class='col-auto'>
                                <button type='button' class='btn btn-sm btn-primary' onClick={() => consumerStore.list()}>Search</button>
                            </div>
                        </span>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-12'>

                        {queryFilter.search && <div class='w-100 text-left mt-2 mb-5'>
                            <h1><i class='fas fa-search' /> Search results</h1>
                            Found {consumerStore.total || 0} results in your search for "{queryFilter.search}".<br />
                            <button class='btn btn-sm btn-warning mt-2'
                                onClick={() => consumerStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true })}
                            >
                                <i class='fas fa-times' /> Reset search
                            </button>
                        </div>}


                        <div class='table-responsive'>
                            <table class={`${style.table} table table-striped table-sm table-borderless`}>
                                <thead>
                                    {consumerStore.sort !== consumerStore.defaultSort && <tr>
                                        <th colspan='8'>
                                            <span class={`${style.pointerCursor} mr-2 badge badge-pill badge-secondary`} onClick={() => consumerStore.resetSort()}>
                                                <i class='fas fa-times-circle' /> Reset sort
                                            </span>
                                        </th>
                                    </tr>}
                                    <tr>
                                        <th style='width: 15%'>
                                            <span class={style.pointerCursor} onClick={() => consumerStore.toggleSort('email', '-')}>
                                                email {util.getSortIcon('email', consumerStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%'>
                                            <span class={style.pointerCursor} onClick={() => consumerStore.toggleSort('receive_info', '-')}>
                                                receive_info {util.getSortIcon('receive_info', consumerStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%'>
                                            <span class={style.pointerCursor} onClick={() => consumerStore.toggleSort('fname', '')}>
                                                fname {util.getSortIcon('fname', consumerStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%'>
                                            <span class={style.pointerCursor} onClick={() => consumerStore.toggleSort('lname', '')}>
                                                lname {util.getSortIcon('lname', consumerStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%'>
                                            <span class={style.pointerCursor} onClick={() => consumerStore.toggleSort('address1', '')}>
                                                address1 {util.getSortIcon('address1', consumerStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%'>
                                            <span class={style.pointerCursor} onClick={() => consumerStore.toggleSort('postalcode', '')}>
                                                postalcode {util.getSortIcon('postalcode', consumerStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%'>
                                            <span class={style.pointerCursor} onClick={() => consumerStore.toggleSort('postalplace', '')}>
                                                postalplace {util.getSortIcon('postalplace', consumerStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%'>
                                            <span class={style.pointerCursor} onClick={() => consumerStore.toggleSort('country_name', '')}>
                                                country_name {util.getSortIcon('country_name', consumerStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%'>
                                            <span class={style.pointerCursor} onClick={() => consumerStore.toggleSort('rods', '')}>
                                                rods {util.getSortIcon('rods', consumerStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%'>
                                            <span class={style.pointerCursor} onClick={() => consumerStore.toggleSort('updated', '')}>
                                                updated {util.getSortIcon('updated', consumerStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%'>
                                            Delete
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {consumers && consumers.map(consumer => (
                                        <tr class={`${style.tableline} ${deleted[consumer.id] ? 'text-muted' : ''}`} style={`${deleted[consumer.id] ? 'text-decoration: line-through;' : ''}`}>
                                            <td>
                                                {!deleted[consumer.id] ? <a href={`/consumers/${consumer.id}/Basics`}>{consumer.email}</a> : <span>{consumer.email}</span>}
                                            </td>
                                            <td>
                                                {consumer.receive_info}
                                            </td>
                                            <td>
                                                {consumer.fname}
                                            </td>
                                            <td>
                                                {consumer.lname}
                                            </td>
                                            <td>
                                                {consumer.address1}
                                            </td>
                                            <td>
                                                {consumer.postalcode}
                                            </td>
                                            <td>
                                                {consumer.postalplace}
                                            </td>
                                            <td>
                                                {consumer.country_name}
                                            </td>
                                            <td>
                                                {consumer.rods && Object.keys(consumer.rods).map(serial => <a class='mr-2 float-left' href={`/rodregs/${serial}/Basics`}>{serial}</a>)}
                                            </td>
                                            <td>
                                                {consumer.updated}
                                            </td>
                                            <td>
                                                <nobr>
                                                    {!deleted[consumer.id] && <a class='btn btn-sm btn-danger' data-id={consumer.id} onClick={this.delete}>
                                                        <i class={`fas fa-trash`} /> Delete
                                                    </a>}
                                                </nobr>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
                {loading && <div class='row'>
                    <div class='col-12 text-center'>
                        <div class='spinner-border text-success' role='status'>
                            <span class='sr-only'>Loading...</span>
                        </div>
                    </div>
                </div>}
                <div class='text-center mt-4 mb-2'>
                    <small class='text-muted'>
                        <i class='fas fa-ellipsis-h' />
                    </small>
                </div>
            </div>
        );
    }
}

export default ConsumerList;




// WEBPACK FOOTER //
// ./components/consumers/list.js